import { Injectable } from '@angular/core';
import { PayloadPayPal } from '@cargos/sprintpay-models';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PayPalService {
    private payload = new BehaviorSubject<PayloadPayPal | null>(null);

    setDataMethodPayPal(payload: PayloadPayPal): void {
        this.payload.next(payload);
    }

    getDataMethodPayPal(): Observable<PayloadPayPal | null> {
        return this.payload.asObservable();
    }
}
